import { inject, Injectable, signal } from "@angular/core";
import { I18n } from "@corporate/ng-tebis-base-components";
import { ProcessNavigationData } from "../../../02_ui/process-navigation/process-navigation.component";

@Injectable({
  providedIn: 'root'
})
export class OrderNavbarService {

  i18n = inject(I18n);

  organizationExpanded = signal(false);

  processNavigationData = <ProcessNavigationData>{
    processGroups: [
      {
        label: this.i18n.translate('manufacturing-order:inquiry'),
        expanded: signal(true),
        processes: [
          {
            label: this.i18n.translate('manufacturing-order:reviewAndClarification'),
            doneAutomatically: signal(true),
            doneManually: signal(false),
          },
          {
            label: this.i18n.translate('manufacturing-order:feasibility'),
            doneAutomatically: signal(true),
            doneManually: signal(false),
          },
        ],
      },
      {
        label: this.i18n.translate('manufacturing-order:offer'),
        expanded: signal(false),
        processes: [
          {
            label: this.i18n.translate('manufacturing-order:classificationAndCalculation'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
          {
            label: this.i18n.translate('manufacturing-order:capacityPlanning'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
        ],
      },
      {
        label: this.i18n.translate('manufacturing-order:order'),
        expanded: signal(false),
        processes: [
          {
            label: this.i18n.translate('manufacturing-order:roughPlanning'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
          {
            label: this.i18n.translate('manufacturing-order:finePlanning'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
          {
            label: this.i18n.translate('manufacturing-order:productionProgress'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
        ],
      },
      {
        label: this.i18n.translate('manufacturing-order:closure'),
        expanded: signal(false),
        processes: [
          {
            label: this.i18n.translate('manufacturing-order:timetrackingAndPostCalculation'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
          {
            label: this.i18n.translate('manufacturing-order:billing'),
            doneAutomatically: signal(false),
            doneManually: signal(false),
          },
        ],
      },
    ],
  };
}
